// The settings tooltip would cover the neighbouring rows inside the narrow history
// panel, so move the card outside the tree: left of it when the viewport has room,
// otherwise right of it, centred on the hovered row (the trigger wraps the row).
// When neither side fits (the sidebar spans the viewport below lg) react-tooltip's
// own placement stays.
//
// react-tooltip@3 calls overridePosition with two different argument orders
// (showTooltip vs updatePosition), so resolve the trigger/tooltip nodes by scanning
// the args rather than relying on fixed positions.
const GAP = 8
const VIEWPORT_MARGIN = 8

export const placeTooltipBesideTree = (position, ...rest) => {
  const nodes = rest.filter((arg) => arg && typeof arg.getBoundingClientRect === 'function')
  const tooltip = nodes.find((el) => el.classList && el.classList.contains('cgt-tooltip'))
  const trigger = nodes.find((el) => el !== tooltip)
  const tree = trigger?.closest?.('.variations-tree')

  if (!tooltip || !tree) {
    return position
  }

  const { width, height } = tooltip.getBoundingClientRect()
  const treeRect = tree.getBoundingClientRect()
  const leftOfTree = treeRect.left - GAP - width
  const rightOfTree = treeRect.right + GAP
  const fitsLeft = leftOfTree >= VIEWPORT_MARGIN
  const fitsRight = rightOfTree + width <= window.innerWidth - VIEWPORT_MARGIN

  if (!fitsLeft && !fitsRight) {
    return position
  }

  const triggerRect = trigger.getBoundingClientRect()
  const centered = triggerRect.top + (triggerRect.height / 2) - (height / 2)
  const top = Math.max(VIEWPORT_MARGIN, Math.min(centered, window.innerHeight - height - VIEWPORT_MARGIN))

  return { left: fitsLeft ? leftOfTree : rightOfTree, top }
}

export default placeTooltipBesideTree
